const toggleDeviceAsCloudPrinter = () => {
  const cloudPrintingDevice =
    JSON.parse(
      localStorage.getItem("cpd") || "false"
    )

  localStorage.setItem("cpd", JSON.stringify(!cloudPrintingDevice))
}

export default toggleDeviceAsCloudPrinter